import { FlexContainer } from '@/ui';
import { AppChip } from '@/ui/chip';
import { PlusIcon } from '@/utils/helpers';
import React from 'react';
import styled, { css } from 'styled-components';

const SimulationOption = styled.div<{
  disabled?: boolean;
  isModal?: boolean;
}>`
  background-color: var(--white-main);
  border: 1px solid var(--gray-light);
  border-radius: var(--box-border-radius);
  padding: var(--medium-padding);
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: ${({ isModal }) => (isModal ? '140px' : '376px')};
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  height: 119px;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        .chip-label {
          transition: all 0.3s ease;
          opacity: 0;
          max-height: 0;
          margin-bottom: 0;
          padding: 0;
          overflow: hidden;
        }

        svg {
          transform: rotate(-90deg);

          path {
            fill: var(--green-color);
          }
        }

        p {
          opacity: 1;
          transform: translateY(0);
          max-height: 50px;
          margin-top: var(--xxsmall-padding);
        }
      }
    `}

  .chip-label {
    transition: all 0.3s ease;
    opacity: 1;
    max-height: 50px;
    overflow: hidden;
  }

  p {
    font-size: var(--xsmall-font-size);
    color: var(--gray-deep);
    font-weight: 400;
    line-height: var(--xsmall-line-height);
    margin: 0;
    opacity: 0;
    transform: translateY(-10px);
    max-height: 0;
    overflow: hidden;
    transition: all 0.3s ease;
  }

  &:hover {
    background-color: rgba(255, 255, 255, 0.5);
  }
`;

const OptionText = styled.div`
  color: var(--black-main);
  font-size: var(--small-font-size);
  font-weight: 500;
  line-height: var(--small-line-height);
`;

const OptionIcon = styled.div`
  margin-top: var(--xsmall-padding);

  svg {
    transition: all 0.3s ease;
  }
`;

type AddButtonProps = {
  title: string;
  description: string;
  id?: string;
  chipLabel?: string;
  disabled?: boolean;
  onClick?: () => void;
  isModal?: boolean;
};

export const AddButton: React.FC<AddButtonProps> = ({
  title,
  description,
  id,
  chipLabel,
  disabled,
  onClick,
  isModal = false,
}) => {
  return (
    <SimulationOption
      id={id}
      onClick={onClick}
      isModal={isModal}
      disabled={disabled}
    >
      <FlexContainer
        direction="column"
        justify="center"
        align="center"
        className="overflow-hidden"
      >
        {chipLabel && (
          <AppChip
            size="xs"
            className="chip-label w-min mb-2"
            label={chipLabel}
            type="primary"
            pulsate
          />
        )}
        <OptionText
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
      </FlexContainer>
      <p>{description}</p>
      <OptionIcon>
        <PlusIcon />
      </OptionIcon>
    </SimulationOption>
  );
};
